// StatusBadge.jsx
import React from 'react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { FaSpinner } from 'react-icons/fa';
import Language_i18 from '../js/useNationalLanguage.jsx';

const translations = {
  vi: {
    processing: "Đang xử lý",
    completed: "Hoàn tất",
    show: "Đang hiện",
    inProgress: "Đang chạy",
    processingError: "Dịch vụ này hẹo đang chờ hoàn tiền",
    failed: "Thất bại",
    hide: "Bị cấm hoặc đã xóa",
    other: "Khác"
  },
  en: {
    processing: "Processing",
    completed: "Completed",
    show: "Showing",
    inProgress: "In progress",
    processingError: "This service failed, awaiting refund",
    failed: "Canceled",
    hide: "Banned or deleted",
    other: "Other"
  }
};

export default function StatusBadge({ status }) {
  const { lang } = Language_i18();
  const t = translations[lang];

  if (status === 'xuly' || status === 'Pending' || status === 'Processing') {
    return <span className="text-black text-wrap badge bg-info">{t.processing}</span>;
  } else if (status === 'hoantat' || status === 'thanhcong' || status === 'Completed') {
    return (
      <span className="badge rounded-pill bg-success text-wrap">
        <AiFillCheckCircle className="inline-block align-middle" /> {t.completed}
      </span>
    );
  } else if (status === 'show') {
    return <span className="badge rounded-pill bg-success text-wrap">{t.show}</span>;
  } else if (status === 'In progress') {
    return (
      <span className="badge rounded-pill bg-purple-500 text-wrap">
        <FaSpinner className="animate-spin inline-block align-middle" /> {t.inProgress}
      </span>
    );
  } else if (status === 'processing') {
    return <span className="text-wrap badge bg-danger">{t.processingError}</span>;
  } else if (status === 'thatbai' || status === 'Canceled') {
    return <span className="text-wrap badge bg-danger">{t.failed}</span>;
  } else if (status === 'hide') {
    return <span className="text-wrap badge bg-danger">{t.hide}</span>;
  } else {
    return <span className="text-wrap badge bg-secondary">{t.other}</span>;
  }
}
